/*
 * @fileOverView Form component definition
 */

import Vue from "vue";

/**
 * Signup Confirmation.
 *
 * @type {class}
 */
Vue.component("signup-confirmation", {
  template: `
    <div v-if="isMounted" class="modal modal_centered modal_form modal_form_newsletter" @click="handleUnmount">
      <button tabindex="0" class="js-beforeContent"></button>
      <div class="modal-content modal-content_centered">
        <div class="modal-content-close hidden-sm-down">
          <button type="button" aria-label="Close modal" class="btn btn_iconCircled" @click="handleUnmount">
            <svg focusable="false" class="icon icon_close-btn icon_13 icon_fillSlate6 icon_closeModal">
              <use xlink:href="/themes/custom/fox/assets/icons/sprites/icons.svg#close-btn"></use>
            </svg>
          </button>
        </div>
        <div class="modal-content-container">
          <div class="modal-content-inner">
            <form novalidate="novalidate" class="forms forms_newsletter forms_inlineFieldWithCta">
                <div class="outline outline_white outline_hiddenSmDown">
                  <div class="outline-title">
                    <span class="txt txt_19 txt_22Md txt_27Lg txt_34Xl txt_bold txt_colorSlate7 txt_line14">
                      Here. Until Parkinson's isn't.
                    </span>
                  </div>
                  <div class="forms-content">
                  <div class="forms-content-headline">
                    <span class="txt txt_17 txt_19Xl txt_line15 txt_medium txt_colorBlue5">
                      Join us as we work to find a cure for the 6 million people worldwide living with Parkinson's.
                    </span>
                    <p class="txt txt_17 txt_19Xl txt_line15 txt_bold txt_colorBlue5 forms-content-footnotes">
                      Thank you for signing up!
                    </p>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div class="modal-footer hidden-md-up">
        <button class="btn btn_text floatRight" @click="handleUnmount">
          <span class="txt txt_14 txt_17Md txt_19Lg txt_colorOrange3 txt_semiBold">Close</span>
        </button>
      </div>
      <button tabindex="0" class="js-afterContent"></button>
    </div>
  `,
  methods: {
    handleUnmount() {
      this.isMounted = false;
      document.body.classList.remove("noScroll");
    },
  },
  mounted() {
    setTimeout(() => document.body.classList.add("noScroll"), 500);
  },
  data: () => {
    return {
      isMounted: true,
    };
  },
});
